import React from 'react';
import { Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SubCard from 'src/components/cards/SubCard';
import ServiceReportCard from 'src/views/ServicePerformanceCharts/ServiceReportCard';
import ServiceComplaint from 'src/views/ServicePerformanceCharts/ServiceComplaint';
import ServiceNps from 'src/views/ServicePerformanceCharts/ServiceNps';
import ServiceAverageTime from 'src/views/ServicePerformanceCharts/ServiceAverageTime';
import ServiceRejectRate from 'src/views/ServicePerformanceCharts/ServiceRejectRate';
import ServiceAppointmentConformity from 'src/views/ServicePerformanceCharts/ServiceAppointmentConformity';
import ServiceExtraWarrantyAndTurnover from 'src/views/ServicePerformanceCharts/ServiceExtraWarrantyAndTurnover';
import ServiceComplementaryProductAndTurnover from 'src/views/ServicePerformanceCharts/ServiceComplementaryProductAndTurnover';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },
    rootlist: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 550,
    },
    rootlistsag: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 500,
    },

    cardBolum: {
        maxHeight: 700,
        minHeight: 700,
        width: '100%'
    },
    table: {
        minWidth: 650,
    },
    content: {
        minHeight: 550,
    },
    chatSection: {
        width: '100%',
    },
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        overflowY: 'auto'
    },
    button: {
        margin: theme.spacing(1),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1500,
        color: '#fff',
    },
    actionsCCFile: {
        justifyContent: 'flex-end'
    }
}));



const ServicePerformance = ({ ServiceShopId, ServiceShopFullName, TopServiceShopCode, EmployeeRole }) => {
    const classes = useStyles();



    return (
        <SubCard title={ServiceShopFullName}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={6}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="EK GARANTİ" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceExtraWarrantyAndTurnover ServiceShopId={ServiceShopId} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="TAMAMLAYICI ÜRÜN" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceComplementaryProductAndTurnover ServiceShopId={ServiceShopId} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Karne Sonuçları" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceReportCard
                                    ServiceShopId={ServiceShopId}
                                    TopServiceShopCode={TopServiceShopCode}
                                />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Şikayet" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceComplaint ServiceShopId={ServiceShopId}
                                    EmployeeRole={EmployeeRole} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="NPS" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceNps ServiceShopId={ServiceShopId}
                                    EmployeeRole={EmployeeRole} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Randevuya Uyum" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceAppointmentConformity ServiceShopId={ServiceShopId}
                                    EmployeeRole={EmployeeRole} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Ortalama Hizmet Süresi" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceAverageTime ServiceShopId={ServiceShopId}
                                    EmployeeRole={EmployeeRole} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Red oranları ve nedenleri" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceRejectRate ServiceShopId={ServiceShopId} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
            </Grid>
        </SubCard>


    );
};



export default ServicePerformance;